import { render } from "./CampaignReport.vue?vue&type=template&id=163d65be&scoped=true"
import script from "./CampaignReport.vue?vue&type=script&lang=js"
export * from "./CampaignReport.vue?vue&type=script&lang=js"

import "./CampaignReport.vue?vue&type=style&index=0&id=163d65be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163d65be"]])

export default __exports__